import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    deleteDailyTempWorker,
    DeleteDailyTempWorkerResponse,
    createDailyTempWorker,
    CreateDailyTempWorkerBody,
    DailyTempWorkerResponse,
    updateDailyTempWorker,
    UpdateDailyTempWorkerBody,
} from '../../services/apiSLTP/dailyReports/dailyTempWorkers';

type UseDeleteDailyTempWorkerMutationOptions = MutationOptions<DeleteDailyTempWorkerResponse, Error, { id: string }>;

export const useDeleteDailyTempWorkerMutation = (options?: UseDeleteDailyTempWorkerMutationOptions) => {
    const deleteDailyTempWorkerMutation: MutationFunction<DeleteDailyTempWorkerResponse, { id: string }> = async ({ id }) => {
        try {
            const response: DeleteDailyTempWorkerResponse = await deleteDailyTempWorker(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily temp worker');
        }
    };

    return useMutation(deleteDailyTempWorkerMutation, options);
};

type UseCreateDailyTempWorkerMutationOptions = MutationOptions<DailyTempWorkerResponse, Error, { body: CreateDailyTempWorkerBody }>;

export const useCreateDailyTempWorkerMutation = (options?: UseCreateDailyTempWorkerMutationOptions) => {
    const createDailyTempWorkerMutation: MutationFunction<DailyTempWorkerResponse, { body: CreateDailyTempWorkerBody }> = async ({ body }) => {
        try {
            const response: DailyTempWorkerResponse = await createDailyTempWorker(body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily temp worker');
        }
    };

    return useMutation(createDailyTempWorkerMutation, options);
};

type UseDailyTempWorkerMutationOptions = MutationOptions<DailyTempWorkerResponse, Error, { id: string; body: UpdateDailyTempWorkerBody }>;

export const useDailyTempWorkerMutation = (options?: UseDailyTempWorkerMutationOptions) => {
    const updateDailyTempWorkerMutation: MutationFunction<DailyTempWorkerResponse, { id: string; body: UpdateDailyTempWorkerBody }> = async ({
        id,
        body,
    }) => {
        try {
            const response: DailyTempWorkerResponse = await updateDailyTempWorker(id, body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily temp worker');
        }
    };

    return useMutation(updateDailyTempWorkerMutation, options);
};
